import type { UserProfile } from 'store/users/types'

import { AgentBadge } from '@rentspree/component-v2/dist/agent-badge'
import styled from 'styled-components'

import { Section, Affix } from 'components'
import { ApplyPanel } from 'containers/public-listing/apply-panel'
import { COLOR } from 'styles/constants'

const MobileSidebar = styled.div`
  margin: 0;
  padding: 10px 20px;
`

const StickyFooter = styled.div`
  .sticky-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 0;
    top: inherit !important;
    width: 100vw;
    margin-bottom: -180px;
    transition: all 0.5s ease-in-out;
    z-index: 11;

    & > div {
      padding-bottom: 30px;
    }

    &.affix-active {
      margin-bottom: 0;
    }

    #applyButtonMobileSticky span,
    #contactButtonMobileSticky span {
      font-size: 14px !important;
    }
  }
`
interface ListingApplyPanelMobileProps {
  isPreview?: boolean
  agentContact: AgentContact
  handleAgentInfoClick: (e: React.MouseEvent) => void
  handleApply: (e: React.MouseEvent) => void
  handleContactClick: (e: React.MouseEvent) => void
  profile?: UserProfile
}

export const ListingApplyPanelMobile = ({
  agentContact,
  handleAgentInfoClick,
  handleApply,
  isPreview,
  handleContactClick,
  profile,
}: ListingApplyPanelMobileProps) => {
  const isAgentBadgeClickable = !isPreview && agentContact.slug
  return (
    <MobileSidebar id="mobile-sidebar">
      <Section title="" $mPadding="0" $mMargin="0 0 30px">
        <AgentBadge
          type="secondary"
          onClick={isAgentBadgeClickable ? handleAgentInfoClick : undefined}
          id="agentProfileMobile"
          {...agentContact}
          titleSize="14px"
          subTitleSize="12px"
          titleLineHeight="24px"
          subTitleLineHeight="16px"
          titleWeight="700"
          subTitleWeight="700"
          titleColor={isAgentBadgeClickable ? COLOR.BLUE_LV2 : COLOR.GREY_LV1}
          titleHoverColor={isAgentBadgeClickable ? COLOR.BLUE_LV4 : COLOR.GREY_LV1}
        />
      </Section>
      <ApplyPanel
        $mt={20}
        $mb={40}
        onApplyClick={(e) => !isPreview && handleApply(e)}
        onContactClick={(e) => !isPreview && handleContactClick(e)}
        contactButtonId="contactButtonMobile"
        applyButtonId="applyButtonMobile"
        isPreview={isPreview}
        profile={profile}
      />
      <div id="sticky-show" />
      <StickyFooter>
        <Affix idleClassName="sticky-footer" target="#sticky-show">
          <ApplyPanel
            $mt={20}
            onApplyClick={(e) => !isPreview && handleApply(e)}
            onContactClick={(e) => !isPreview && handleContactClick(e)}
            contactButtonId="contactButtonMobileSticky"
            applyButtonId="applyButtonMobileSticky"
            isSticky
            isPreview={isPreview}
            profile={profile}
            disableShare
          />
        </Affix>
      </StickyFooter>
    </MobileSidebar>
  )
}

ListingApplyPanelMobile.defaultProps = {
  isPreview: false,
  profile: {},
}
